// import { resolve } from "path"
import api from "../api"
import {  imageTamperingDetectionApi} from "../apiVariables"


export const imageDetectionPost = (body: any)=>{
    return new Promise((resolve, reject) => {
        api({ ...imageTamperingDetectionApi.imagePost, body }).then((res) => {
            resolve(res)
        }).catch((error) => {
            reject(error)
        })
    })
}

export const pullResultGet = (id: string | number, body?: any) => {
  return new Promise((resolve, reject) => {
    api({ ...imageTamperingDetectionApi.pullApiGet(id), body })
      .then((res) => resolve(res))
      .catch((error) => reject(error));
  });
};